import { ScatterplotLayer } from 'deck.gl';

export const gpsLayer = (gpsData: any) => {
  const gpsDataWithIndex = gpsData.map((d: any, i: number) => {
    return { ...d, index: i };
  });

  return new ScatterplotLayer({
    id: 'gps-layer',
    data: gpsDataWithIndex,

    pickable: true,
    opacity: 1,
    stroked: true,
    filled: true,
    radiusScale: 4,
    radiusMinPixels: 6,

    lineWidthMinPixels: 1,
    getPosition: (d) => {
      return [d.lon, d.lat];
    },

    //@ts-ignore
    getFilterValue: (d) => d.timestamp,

    autoHighlight: true,
    // Orange
    highlightColor: [255, 165, 0],

    // onHover: (info) => {
    //   if (!info.object) {
    //     setPopupProps(null);
    //     return;
    //   }
    //   const closestSensorIndex = sensorData.reduce(
    //     (closestIndex, currentSensor, index) => {
    //       const currentDiff = Math.abs(
    //         currentSensor.timestamp - info.object.timestamp,
    //       );
    //       const closestDiff = Math.abs(
    //         sensorData[closestIndex].timestamp - info.object.timestamp,
    //       );
    //       return currentDiff < closestDiff ? index : closestIndex;
    //     },
    //     0,
    //   );
    //   setClosestSensorIndex(closestSensorIndex);

    //   let gpsTimestamp = info.object.timestamp * 1000;
    //   if (info.object.index === gpsDataWithIndex.length - 1) {
    //     gpsTimestamp -= 1; // Si c'est le dernier index, on décrémente de 1s pour faire en sorte que point n'appartient pas à la leg suivante.
    //   }
    //   const leg = events.find((leg) => {
    //     return (
    //       gpsTimestamp >= Date.parse(leg.start_datetime) &&
    //       gpsTimestamp < Date.parse(leg.end_datetime)
    //     );
    //   })!;

    //   // Compute the progress of the leg
    //   const progress = Math.round(
    //     ((gpsTimestamp - Date.parse(leg!.start_datetime)) /
    //       (Date.parse(leg.end_datetime) - Date.parse(leg.start_datetime))) *
    //       100,
    //   );

    //   setPopupProps({
    //     gpsPoint: {
    //       lat: info.object.lat,
    //       lon: info.object.lon,
    //       timestamp: info.object.timestamp,
    //     },
    //     progress,
    //     mapRef,

    //     leg,
    //   });
    // },

    // filterRange: tsRange,
    // highlightedObjectIndex: highlightedIndex,

    getFillColor: [255, 255, 255],
    getLineColor: [0, 0, 0],
    // getCursor: ({
    //   isHovering,
    //   isDragging,
    // }: {
    //   isHovering: boolean;
    //   isDragging: boolean;
    // }) => {
    //   if (isHovering) {
    //     mapRef.current.setOptions({ draggableCursor: 'pointer' });
    //   } else {
    //     mapRef.current.setOptions({ draggableCursor: '' });
    //   }
    //   return 'grab';
    // },
  });
};
